import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { USER_MENTION } from '../constants';
import type { UserMentionElement } from '../types';

export const isMention = isElementType<UserMentionElement>(USER_MENTION);
